import React from 'react';
import { SvgIcon } from '@mui/material';

export function BoltIcon({ sx, ...props }) {
  return (
    <SvgIcon
      viewBox="0 0 25 25"
      sx={{ width: 25, height: 25, ...sx }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.68226 14.503C6.46499 14.503 6.38534 14.3529 6.50467 14.1673L13.284 3.62177C13.4031 3.43637 13.4998 3.46432 13.4998 3.69442V10.0886C13.4998 10.3141 13.6823 10.497 13.8932 10.497H17.9136C18.1309 10.497 18.2105 10.6471 18.0912 10.8327L11.3119 21.3782C11.1927 21.5636 11.0961 21.5357 11.0961 21.3056V14.9114C11.0961 14.6859 10.9135 14.503 10.7027 14.503H6.68226Z"
        fill="#FABA5A"
      />
    </SvgIcon>
  );
}
